
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail",
      function () {
        return require("private-next-pages/retail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retail"])
      });
    }
  